@let resultValue = result();

@if (resultValue) {
  @switch (resultValue.status) {
    @case ('in_progress') {
      <ng-container [ngTemplateOutlet]="inProgressTemplate"></ng-container>
    }
    @case ('success') {
      <ng-container [ngTemplateOutlet]="successTemplate"></ng-container>
    }
    @case ('error') {
      <ng-container [ngTemplateOutlet]="errorTemplate"></ng-container>
    }
  }
} @else {
  <ng-container [ngTemplateOutlet]="nullTemplate"></ng-container>
}

<ng-template #inProgressTemplate>
  <div class="flex items-center">
    <!-- Left column: emoji -->
    <div class="text-2xl flex-shrink-0 mr-3">⌛</div>
    <!-- Right column: text -->
    <div class="flex flex-col">
      <span class="font-bold">Evaluate {{ type() }} speed:</span>
      <span>{{ $safeNavigationMigration(resultValue?.bytesPerSecond) | toMbps }} Mbps</span>
    </div>
  </div>
</ng-template>

<ng-template #successTemplate>
  <div class="flex items-center">
    <div class="text-2xl flex-shrink-0 mr-3">✅</div>
    <div class="flex flex-col">
      <span class="font-bold">{{ type() | titlecase }} Speed:</span>
      <span>{{ $safeNavigationMigration(resultValue?.bytesPerSecond) | toMbps }} Mbps</span>
    </div>
  </div>
</ng-template>

<ng-template #errorTemplate>
  <div class="flex items-center">
    <div class="text-2xl flex-shrink-0 mr-3">❌</div>
    <div class="flex flex-col">
      <span class="font-bold">{{ type() | titlecase }} Speed:</span>
      <span>{{ $safeNavigationMigration(resultValue?.bytesPerSecond) | toMbps }} Mbps</span>
    </div>
  </div>
</ng-template>

<ng-template #nullTemplate>
  <p>null</p>
</ng-template>
